<template>
  <v-badge inline left small color="blue-grey darken-1">
    <span slot="badge">{{ rank }}</span>
    <v-menu bottom offset-y>
      <template v-slot:activator="{ on }">
        <v-btn
          small
          class="btn-rank"
          fab
          v-on="on"
          >
          <v-icon class="ico-rank" :color="rankColor">
            lens
          </v-icon>
        </v-btn>
      </template>

      <v-list dense class="popup-list pb-0">
        <v-list-item v-for="(displayValue, d) in displayValues" :key="d">
          <v-list-item-content>
            <v-list-item-title>{{ displayValue.description }}</v-list-item-title>
            <v-list-item-subtitle><b>{{ displayValue.value }}</b></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider v-if="displayValues.length > 0" />

        <v-list-item v-for="(criterion, c) in criteriaTraits" :key="c + 10">
          <v-list-item-content>
            <v-list-item-title class="mr-2 font-weight-bold">
              {{ getTraitDescription(criterion.id) }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ getTraitValue(criterion.id, criterion.value) }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-avatar>
            <v-icon v-if="criterion.isMatch" color="green">
              done
            </v-icon>
            <v-icon v-else color="red">
              clear
            </v-icon>
          </v-list-item-avatar>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-badge>
</template>


<script>
export default {
  name: 'AnimalRankMenu',
  props: {
    rank: {
      type: Number,
      default: 0
    },
    rankColor: {
      type: String,
      default: null
    },
    displayValues: {
      type: Array,
      default: null
    },
    criteriaTraits: {
      type: Array,
      default: null
    },
    criterionDescriptions: {
      type: Array,
      default: null
    }
  },
  methods: {    
    getTraitDescription (id) {
      const descs = this.criterionDescriptions.filter(c => { return c.id === id })
      return descs.length > 0
        ? descs[0].trait
        : ''
    },

    getTraitValue (id, v) {
      var value = v === null ? '' : v
      const isNumber = !isNaN(value)

      if (isNumber) {
        if (value.indexOf('.') >= 0) {
          value = new Number(value).toFixed(2).toString()
        } 
      }
      const descs = this.criterionDescriptions.filter(c => { return c.id === id })
      return descs.length > 0
        ? value.length > 0
          ? value + ' ' + descs[0].unit
          : 'N/A'
        : ''
    }
  }
}
</script>

<style>
.ico-rank {
  font-size: 14px !important;
}

.btn-rank {
  width: 24px !important;
  height: 24px !important;
}
</style>
